import React from "react";
import {
    Avatar,
    makeStyles,
    Card,
    CircularProgress,
} from "@material-ui/core";


const useStyles = makeStyles(() => ({
    centerHorizontal: {
        marginLeft: "auto",
        marginRight: "auto",
    },
    flex1: {
        flexGrow: 1,
    },
    avatarLoading: {
        width: "130px",
        height: "130px",
        marginTop: "calc(40% - 16px)",
        marginLeft: "20px",
        marginRight: "20px",
    },
    loading: {
        marginTop: "40%",
        position: "absolute",
        top: "-26px",
        left: "10px",
    },
    info: {
        position: "relative",
    },
}));


export default function LookingForOpponent(): JSX.Element {
    const classes = useStyles();

    return (
        <Card elevation={0} className={`${classes.centerHorizontal} ${classes.info} ${classes.flex1}`}>
            <CircularProgress size={150} className={`${classes.loading}`} />
            <Avatar className={`${classes.avatarLoading}`}>
                ?
            </Avatar>
        </Card>
    );
}
